var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "24px",
    viewBox: "0 0 18 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "draw",
    transform: "translate(0.000000, 3.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1928446,3.00396811 L14.8544518,6.68347314 L5.58591287,15.997403 L1.9263817,12.317898 L11.1928446,3.00396811 Z M17.6329034,2.11655585 L15.9999675,0.47562294 C15.3688941,-0.15854098 14.3441614,-0.15854098 13.710944,0.47562294 L12.1467547,2.04747258 L15.8083619,5.72701182 L17.6329034,3.89353493 C18.1223655,3.40164152 18.1223655,2.60841507 17.6329034,2.11655585 Z M0.0101893888,17.4897385 C-0.0564471653,17.7911057 0.214319139,18.0611461 0.514251699,17.9878563 L4.59449843,16.9937069 L0.934967266,13.3142019 L0.0101893888,17.4897385 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.1ccc6293bb6ede576b316a92ce3f40a4.svg";
export { ForwardRef as ReactComponent };